var cilMedicalCross = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M344,16H168V168H16V344H168V496H344V344H496V168H344ZM464,200V312H312V464H200V312H48V200H200V48H312V200Z' class='ci-primary'/>"];

export { cilMedicalCross };
//# sourceMappingURL=cil-medical-cross.js.map
